import { hasCookie } from '@jwplayer/fe-common/module/cookies';

/**
 * This type definition lists all the preview cookie names currently in use.
 *
 * Include a comment saying what it's for!
 */
type PreviewCookie =
  // #region snippet
  /**
   * Ad Server pages: Line items, Creatives, Targeting rules
   */
  `previewAdServer`;
// #endregion snippet

// ℹ️ Note: the `region snippet` comments are used to include this file in our documentation site.

export const hasPreviewCookie: (cookie: PreviewCookie) => boolean = hasCookie;
